import { Button } from 'antd';
import styled from 'styled-components';
import { AIGradientColors, MediaQuery, NeutralColors } from 'theme';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px;
  height: 68px;
  border-bottom: 1px solid ${NeutralColors[20]};

  svg {
    cursor: pointer;
    color: ${NeutralColors[40]};
    fill: ${NeutralColors[40]};
    width: 18px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HistoryWrapper = styled(Button)`
  display: flex;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;

  &&:hover {
    background-color: ${NeutralColors[10]} !important;
  }
`;

const CropwiseAiTitle = styled.h3<{ $isCollapsed: boolean }>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'flex' : 'none')};
  align-items: center;
  margin: 0;
  font-size: 15px;
  line-height: 16.731px;
  letter-spacing: -0.112px;
  background: ${AIGradientColors[60]};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    display: flex;
  }
`;

const Tag = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${NeutralColors[10]};
  height: 24px;
  border-radius: 4px;
  color: ${NeutralColors[70]};
  padding: 0 8px;

  svg {
    color: ${NeutralColors[70]};
    fill: ${NeutralColors[70]};
    width: 18px;
  }

  @media (max-width: ${MediaQuery.screenSizes.desktop - 1}px) {
    display: none;
  }
`;

export {
  ButtonsContainer,
  Container,
  CropwiseAiTitle,
  HistoryWrapper,
  LeftContainer,
  Tag,
};
